module.exports = __webpack_public_path__ + "static/media/ic_chevron_right_white_24px.39755c5d.svg";